export default __webpack_public_path__ + "static/media/final_true_vacant.5c9f42aa.geojson";